<mat-toolbar color="primary" class="toolbar">
    <app-back-button color="secondary" [route]="['/']"></app-back-button>
</mat-toolbar>

<mat-card class="mat-elevation-z0 card">
    <mat-card-content class="body">
        <div fxLayout="column" fxLayoutAlign="center center">
            <mat-form-field *ngIf="!certificateUrl">
                <mat-label>Token</mat-label>
                <input matInput [(ngModel)]="token" />
            </mat-form-field>
            <button mat-raised-button (click)="validate()" [disabled]="!token" color="primary" *ngIf="!certificateUrl">
                {{ "VALIDATES_CERTIFICATE.VALIDATE_TOKEN" | translate }}
            </button>
            <div *ngIf="certificateUrl">
                <b style="color: green">{{ "VALIDATES_CERTIFICATE.SUCCESS" | translate }}</b>
            </div>
            <button mat-raised-button *ngIf="certificateUrl">
                <a [href]="certificateUrl" target="_blank">
                    {{ "VALIDATES_CERTIFICATE.DOWNLOAD" | translate }}
                </a>
            </button>
            <div *ngIf="hasError">
                <b style="color: red">{{ "VALIDATES_CERTIFICATE.ERROR" | translate }}</b>
            </div>
        </div>
    </mat-card-content>
</mat-card>
